module.exports = __webpack_public_path__ + "files/499f690093be517b63d12ebbe82222e0.png";